import styled from '@mui/material/styles/styled';
import Card from '@mui/material/Card';

const CardStyled = styled(Card)(() => ({
  flexGrow: 1,
  width: '45%', 
  margin: 20,
  background: '#338f9d',
  borderRadius: '8px 8px 0px 8px'
}));

export { CardStyled };